import { styles, variants, NavigationListItemTheme } from '../NavigationListItemStyles.css';
import { baseTheme } from './CollapsibleNavigationListItemBaseTheme.css';
import { multiVariantStyles } from './CollapsibleNavigationListItemVariants.css';

const NavigationListItemStableTheme: NavigationListItemTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

export { NavigationListItemStableTheme };
